// extracted by mini-css-extract-plugin
export var container = "_4n-0";
export var icon = "_4n-1";
export var text = "_4n-2";